import React, { useEffect } from 'react';
import Menu from './Menu'

import { connect } from 'react-redux';
import * as actions from '../../actions';
import { connectOrderEvents, disconnectOrderEvents } from '../../services/orderEvents';

function Dashboard({ admin, history, handleLogout, children }) {
	useEffect(() => {
		if (admin?.loja) {
			connectOrderEvents(admin.loja);
		}
		return () => disconnectOrderEvents();
	}, [admin?.loja]);

	return (
		<div className="dashboard">
			<Menu admin={admin} history={history} handleLogout={handleLogout} />
			<div className="TemplateBody">
				{children}
			</div>
		</div>
	);
}

const mapStateToProps = state => ({
	admin: state.auth.usuario
})

export default connect(mapStateToProps, actions)(Dashboard);
